import React from 'react';

const _PinIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="13"
    height="18"
    viewBox="0 0 13 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.31438 1C7.72384 1 9.07557 1.55991 10.0722 2.55654C11.0688 3.55318 11.6288 4.90492 11.6288 6.31438C11.6288 8.82772 7.73154 15.0873 6.61269 16.8368C6.58064 16.8869 6.53651 16.928 6.48439 16.9565C6.43226 16.9851 6.37379 17 6.31438 17C6.25496 17 6.1965 16.9851 6.14437 16.9565C6.09224 16.928 6.04812 16.8869 6.01606 16.8368C4.89721 15.0881 1 8.82772 1 6.31438C1 4.90492 1.55991 3.55318 2.55654 2.55654C3.55318 1.55991 4.90492 1 6.31438 1V1Z"
      stroke="#47D7AC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.3152 8.43998C7.48922 8.43998 8.44095 7.48825 8.44095 6.31423C8.44095 5.14021 7.48922 4.18848 6.3152 4.18848C5.14118 4.18848 4.18945 5.14021 4.18945 6.31423C4.18945 7.48825 5.14118 8.43998 6.3152 8.43998Z"
      stroke="#47D7AC"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PinIcon = React.memo(_PinIcon);
